import { useIntl } from 'react-intl'

import { Button } from '@/components/atoms/Button/Button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  type DialogProps,
  DialogTitle,
} from '@/components/atoms/Dialog/Dialog'
import { InlineError } from '@/components/atoms/InlineError'
import { type PromotionOption } from '@/components/model/PromotionOption'
import { PromotionOptionSummary } from '@/components/molecules/PromotionOptionSummary'

export interface AddToPlanDialogProps extends Pick<DialogProps, 'open' | 'onOpenChange'> {
  readonly option?: PromotionOption
  readonly pending?: boolean
  readonly error?: string
  readonly onConfirm: () => void
}

export const AddToPlanDialog = ({ open, onOpenChange, option, pending, error, onConfirm }: AddToPlanDialogProps) => {
  const intl = useIntl()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[512px]">
        <DialogTitle>{intl.formatMessage({ id: 'promotions.shop.addDialog.title' })}</DialogTitle>
        {option && <PromotionOptionSummary placement={option.placement} fee={option.fee} />}
        <DialogDescription asChild>
          <ul className="flex list-disc flex-col gap-1.5 pl-[18px] text-sm leading-[1.4] text-gray-800">
            <li>{intl.formatMessage({ id: 'promotions.shop.addDialog.billing' })}</li>
            <li>{intl.formatMessage({ id: 'promotions.shop.addDialog.removal' })}</li>
            <li>{intl.formatMessage({ id: 'promotions.shop.addDialog.promotions' })}</li>
          </ul>
        </DialogDescription>
        {error && <InlineError message={error} />}
        <DialogFooter className="pt-2">
          <Button size="sm" className="px-6" disabled={pending} onClick={() => onOpenChange?.(false)}>
            {intl.formatMessage({ id: 'promotions.shop.dialog.cancel' })}
          </Button>
          <Button size="sm" className="px-6" variant="primary" loading={pending} onClick={onConfirm}>
            {intl.formatMessage({ id: 'promotions.shop.addDialog.confirm' })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
